import { CXoneVoiceClient } from '@nice-devone/voice-sdk';
import { MutableRefObject } from 'react';
import { logger } from '../../utils/logger';

export interface WebRtcReadyState {
  isJssipRegistered: boolean;
  audioCodeConnected: boolean;
  webRtcReady: boolean;
}

export function getWebRtcReadyState(voiceClient: CXoneVoiceClient): WebRtcReadyState {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const vc = voiceClient as any;
  const webRtcService = vc?.webRtcService;
  const audioCode = webRtcService?.audioCode;
  const jssipUA = audioCode?.jssipUA;
  const isJssipRegistered = jssipUA?.isRegistered?.() === true;
  const audioCodeConnected = webRtcService?.audioCodeIsConnected === true;

  return {
    isJssipRegistered,
    audioCodeConnected,
    webRtcReady: isJssipRegistered && audioCodeConnected,
  };
}

export function isVoiceConnectionActive(
  status: { status?: string; isLoggedIn?: boolean },
  webRtcReady: boolean
): boolean {
  return status.isLoggedIn === true || status.status === 'login' || webRtcReady;
}

export function tryConnectPendingAgentLeg(
  voiceClient: CXoneVoiceClient,
  pendingLegRef: MutableRefObject<string | null>,
  source: string
): void {
  if (!pendingLegRef.current) {
    return;
  }

  const pendingLegId = pendingLegRef.current;
  logger.debug(`[Events] ${source}: connecting pending agent leg:`, pendingLegId);

  try {
    voiceClient.connectAgentLeg(pendingLegId);
    pendingLegRef.current = null;
    logger.debug(`[Events] Pending agent leg connected successfully (${source})`);
  } catch (connectError) {
    logger.error(`[Events] Failed to connect pending agent leg (${source}):`, connectError);
  }
}

export function storePendingAgentLeg(
  pendingLegRef: MutableRefObject<string | null>,
  legId: string
): void {
  logger.debug('[Events] WebRTC NOT ready - storing pending leg:', legId);
  pendingLegRef.current = legId;
}
